"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var TableItem_1 = __importDefault(require("./TableItem"));
var classnames_1 = __importDefault(require("classnames"));
var QuoteSelectButton_1 = __importDefault(require("./QuoteSelectButton"));
var mobx_1 = require("mobx");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var DiscountPill_1 = __importDefault(require("./DiscountPill"));
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var Expander_1 = require("ContentTokens/SharedWidgetComponents/Expander");
var TableSectionCollapseButton_1 = __importDefault(require("./TableSectionCollapseButton"));
var lodash_1 = require("lodash");
var es_toolkit_1 = require("es-toolkit");
var QuoteBlockStore_1 = __importDefault(require("QuoteV2/Stores/QuoteBlockStore"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var inversify_react_1 = require("inversify-react");
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var QuoteComponents_1 = require("./QuoteComponents");
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var Section_1 = require("./Section");
var c = (0, BemBuilder_1.default)("section");
var TableSection = (function (_super) {
    __extends(TableSection, _super);
    function TableSection(props) {
        var _this = _super.call(this, props) || this;
        _this.sectionRef = react_1.default.createRef();
        _this.selectSection = function () {
            var section = _this.props.section;
            _this.quoteViewStore.setSelectedSection(section.id);
            _this.onClickOutside.startListening();
        };
        _this.deselectSection = function () {
            var _a = _this.props;
            _this.onClickOutside.stopListening();
            _this.quoteViewStore.setSelectedSection(undefined);
        };
        _this.handleSectionHeaderClick = function (event) {
            if (event.target === event.currentTarget) {
                _this.selectSection();
            }
        };
        _this.onClickOutside = new utils_1.OnClickOutside([".".concat(c("", props.section.id)), ".quote-section-toolbar", ".quote-section-toolbar__style-popover"], _this.deselectSection);
        return _this;
    }
    TableSection.prototype.componentWillUnmount = function () {
        this.onClickOutside.stopListening();
    };
    Object.defineProperty(TableSection.prototype, "hasRecurringSubtotals", {
        get: function () {
            var _a;
            var totals = (_a = this.props.section.total.recurringTotals) !== null && _a !== void 0 ? _a : {};
            return (0, lodash_1.filter)(totals, function (total) { return !!total && total.preTax !== 0; }).length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableSection.prototype, "subtotals", {
        get: function () {
            var sectionTotal = this.props.section.total;
            var oneOff = { value: sectionTotal.preTax, frequency: null, preDiscount: sectionTotal.preDiscount };
            var subtotals = [oneOff];
            if (this.hasRecurringSubtotals) {
                Object.keys(sectionTotal.recurringTotals).forEach(function (frequency) {
                    var recurringTotal = sectionTotal.recurringTotals[frequency];
                    if (recurringTotal) {
                        var subtotal = recurringTotal.preTax, preDiscount = recurringTotal.preDiscount;
                        subtotals.push({
                            value: subtotal,
                            frequency: frequency,
                            preDiscount: preDiscount,
                        });
                    }
                });
                return (0, lodash_1.sortBy)((0, lodash_1.filter)(subtotals, function (s) { return s.value !== 0; }), function (s) { return (0, lodash_1.indexOf)(Recurrence_1.recurringFrequencyDisplayOrder, s.frequency); });
            }
            return subtotals;
        },
        enumerable: false,
        configurable: true
    });
    TableSection.prototype.renderSubtotals = function () {
        var _this = this;
        var section = this.props.section;
        var oneOffLabel = this.hasRecurringSubtotals
            ? this.quoteViewStore.getLabel(Types_1.QuoteLabel.OneOff)
            : this.quoteViewStore.getLabel(Types_1.QuoteLabel.SubTotal);
        var hasDiscount = section.discount.enabled && !(0, es_toolkit_1.isNil)(section.discount.units) && section.discount.units !== 0;
        return this.subtotals.map(function (subtotal, index) {
            var frequencyLabel = subtotal.frequency
                ? _this.quoteViewStore.getLabel((0, Recurrence_1.mapRecurringFrequencyToAdjectiveLabel)(subtotal.frequency))
                : undefined;
            return (react_1.default.createElement("div", { className: c("subtotal"), key: "subtotal-".concat(index) },
                react_1.default.createElement("div", { className: c("subtotal-label") }, frequencyLabel !== null && frequencyLabel !== void 0 ? frequencyLabel : oneOffLabel,
                    " ",
                    hasDiscount && (react_1.default.createElement("span", { className: "before-discount-total", "aria-label": "Price before discount" }, _this.quoteCurrencyFormatter.formatWithUserDecimalPreference(subtotal.preDiscount)))),
                react_1.default.createElement("div", { className: c("subtotal-value") },
                    react_1.default.createElement("span", null, _this.quoteCurrencyFormatter.formatWithUserDecimalPreference(subtotal.value)))));
        });
    };
    TableSection.prototype.renderTableHeaders = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _this = this;
        var section = this.props.section;
        var fade = this.quoteViewStore.hideMode === QuoteViewStore_1.QuoteHideMode.Fade;
        var invisible = this.quoteViewStore.hideMode === QuoteViewStore_1.QuoteHideMode.Invisible;
        var columnDisabledReason = "Cannot show this column while all columns are hidden";
        return (react_1.default.createElement("tr", { className: (0, classnames_1.default)(c("row"), c("row", "header")) },
            react_1.default.createElement("th", { className: (0, classnames_1.default)(c("cell"), c("cell", "header"), (_a = {},
                    _a["".concat(c("cell", "invisible"))] = invisible && !section.showItemDescription,
                    _a)) },
                react_1.default.createElement("div", { className: c("cell", "header-item-container") },
                    react_1.default.createElement("span", { className: (0, classnames_1.default)((_b = {},
                            _b["".concat(c("cell", "fade"))] = fade && !section.showItemDescription,
                            _b)) }, this.quoteViewStore.getLabel(Types_1.QuoteLabel.Description)),
                    this.quoteComponents.ColumnVisibilityButton && (react_1.default.createElement(this.quoteComponents.ColumnVisibilityButton, { className: c("cell", "header-button"), toggle: function () {
                            var next = !section.showItemDescription;
                            section.showItemDescription = next;
                            section.showItemRate = next;
                            section.showItemQuantity = next;
                            section.showItemPrice = next;
                            _this.quoteTelemetry.trackColumnVisibility("description", next);
                        }, tooltip: section.showItemDescription ? "Hide All Columns" : "Show All Columns", disabled: false })))),
            react_1.default.createElement("th", { className: (0, classnames_1.default)(c("cell"), c("cell", "header"), (_c = {},
                    _c["".concat(c("cell", "invisible"))] = invisible && !section.showItemRate,
                    _c)) },
                react_1.default.createElement("div", { className: c("cell", "header-item-container") },
                    react_1.default.createElement("span", { className: (0, classnames_1.default)((_d = {},
                            _d["".concat(c("cell", "fade"))] = fade && !section.showItemRate,
                            _d)) }, this.quoteViewStore.getLabel(Types_1.QuoteLabel.Item)),
                    this.quoteComponents.ColumnVisibilityButton && (react_1.default.createElement(this.quoteComponents.ColumnVisibilityButton, { className: c("cell", "header-button"), toggle: function () {
                            section.showItemRate = !section.showItemRate;
                            _this.quoteTelemetry.trackColumnVisibility("item rate", section.showItemRate);
                        }, tooltip: section.showItemRate ? "Hide Column" : "Show Column", disabled: !section.showItemDescription, disabledReason: columnDisabledReason })))),
            react_1.default.createElement("th", { className: (0, classnames_1.default)(c("cell"), c("cell", "header"), (_e = {},
                    _e["".concat(c("cell", "invisible"))] = invisible && !section.showItemQuantity,
                    _e)) },
                react_1.default.createElement("div", { className: c("cell", "header-item-container") },
                    react_1.default.createElement("span", { className: (0, classnames_1.default)((_f = {},
                            _f["".concat(c("cell", "fade"))] = fade && !section.showItemQuantity,
                            _f)) }, this.quoteViewStore.getLabel(Types_1.QuoteLabel.Quantity)),
                    this.quoteComponents.ColumnVisibilityButton && (react_1.default.createElement(this.quoteComponents.ColumnVisibilityButton, { className: c("cell", "header-button"), toggle: function () {
                            section.showItemQuantity = !section.showItemQuantity;
                            _this.quoteTelemetry.trackColumnVisibility("quantity", section.showItemQuantity);
                        }, tooltip: section.showItemQuantity ? "Hide Column" : "Show Column", disabled: !section.showItemDescription, disabledReason: columnDisabledReason })))),
            react_1.default.createElement("th", { className: (0, classnames_1.default)(c("cell"), c("cell", "header"), (_g = {},
                    _g["".concat(c("cell", "invisible"))] = invisible && !section.showItemPrice,
                    _g)) },
                react_1.default.createElement("div", { className: c("cell", "header-item-container") },
                    react_1.default.createElement("span", { className: (0, classnames_1.default)((_h = {},
                            _h["".concat(c("cell", "fade"))] = fade && !section.showItemPrice,
                            _h)) }, this.quoteViewStore.getLabel(Types_1.QuoteLabel.Price)),
                    this.quoteComponents.ColumnVisibilityButton && (react_1.default.createElement(this.quoteComponents.ColumnVisibilityButton, { className: c("cell", "header-button"), toggle: function () {
                            section.showItemPrice = !section.showItemPrice;
                            _this.quoteTelemetry.trackColumnVisibility("price", section.showItemPrice);
                        }, tooltip: section.showItemPrice ? "Hide Column" : "Show Column", disabled: !section.showItemDescription, disabledReason: columnDisabledReason }))))));
    };
    Object.defineProperty(TableSection.prototype, "allColumnsInvisible", {
        get: function () {
            var _a = this.props.section, showItemDescription = _a.showItemDescription, showItemPrice = _a.showItemPrice, showItemQuantity = _a.showItemQuantity, showItemRate = _a.showItemRate;
            return (this.quoteViewStore.hideMode === QuoteViewStore_1.QuoteHideMode.Invisible &&
                !showItemDescription &&
                !showItemPrice &&
                !showItemQuantity &&
                !showItemRate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableSection.prototype, "collapsible", {
        get: function () {
            return !this.allColumnsInvisible;
        },
        enumerable: false,
        configurable: true
    });
    TableSection.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var _c = this.props, section = _c.section, selectSection = _c.selectSection;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c(), c("", section.id), (_a = {},
                _a["".concat(c("", "selected"))] = this.quoteViewStore.selectedSectionId === section.id,
                _a["".concat(c("", "selectable"))] = this.quoteViewStore.isSelectionEnabled,
                _a), "project-block__widget-element"), ref: this.sectionRef },
            this.quoteComponents.SectionToolbar && (react_1.default.createElement(this.quoteComponents.SectionToolbar, { section: section, sectionRef: this.sectionRef })),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(c("banner"), (_b = {},
                    _b["".concat(c("banner", "only"))] = this.allColumnsInvisible || section.collapsed,
                    _b)), onClick: this.handleSectionHeaderClick },
                react_1.default.createElement(DiscountPill_1.default, { discount: section.discount, className: c("discount") }),
                react_1.default.createElement("div", { className: c("title"), onFocus: this.deselectSection },
                    this.quote.showSectionLabels && (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("label"), "user-font") },
                        this.quoteViewStore.getLabel(Types_1.QuoteLabel.Section),
                        " ",
                        this.quote.getSectionLabel(section))),
                    react_1.default.createElement(this.quoteComponents.SectionDescription, { content: section.description })),
                react_1.default.createElement("div", { className: (0, classnames_1.default)(c("details"), "user-font") },
                    this.collapsible && (react_1.default.createElement(TableSectionCollapseButton_1.default, { collapsed: section.collapsed, toggle: function () {
                            var next = !section.collapsed;
                            section.collapsed = next;
                        } })),
                    section.showSubtotal && this.renderSubtotals(),
                    section.showSubtotal && react_1.default.createElement("div", { className: c("subtotals-mobile") }, this.renderSubtotals()),
                    this.quote.quoteSelectionType !== Types_1.QuoteSelectionType.Combined && !section.mandatory && (react_1.default.createElement(QuoteSelectButton_1.default, { selected: section.selected, onClick: function () {
                            selectSection();
                            _this.quoteTelemetry.trackSectionSelectionToggled(_this.quote.quoteSelectionType, section.selected);
                        } })),
                    this.quoteComponents.SectionMenu && react_1.default.createElement(this.quoteComponents.SectionMenu, { section: section }))),
            react_1.default.createElement(Expander_1.Expander, { open: !section.collapsed && !this.allColumnsInvisible },
                react_1.default.createElement("div", { className: c("main"), role: section.itemSingleSelect ? "radiogroup" : undefined },
                    react_1.default.createElement("table", { className: (0, classnames_1.default)(c("table"), "user-font") },
                        react_1.default.createElement("thead", { className: c("header") }, this.renderTableHeaders()),
                        react_1.default.createElement("tbody", { className: c("body") }, section.items.map(function (item) { return (react_1.default.createElement(TableItem_1.default, { key: item.id, section: section, item: item })); }))),
                    this.quoteComponents.SectionFooter && react_1.default.createElement(this.quoteComponents.SectionFooter, { section: section })))));
    };
    var _a, _b, _c, _d, _e, _f;
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_b = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _b : Object)
    ], TableSection.prototype, "quoteCurrencyFormatter", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_c = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _c : Object)
    ], TableSection.prototype, "quoteViewStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteComponents_1.QuoteComponents.$),
        __metadata("design:type", typeof (_d = typeof QuoteComponents_1.QuoteComponents !== "undefined" && QuoteComponents_1.QuoteComponents) === "function" ? _d : Object)
    ], TableSection.prototype, "quoteComponents", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_e = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _e : Object)
    ], TableSection.prototype, "quoteTelemetry", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_f = typeof QuoteBlockStore_1.default !== "undefined" && QuoteBlockStore_1.default) === "function" ? _f : Object)
    ], TableSection.prototype, "quote", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TableSection.prototype, "hasRecurringSubtotals", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], TableSection.prototype, "subtotals", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TableSection.prototype, "allColumnsInvisible", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TableSection.prototype, "collapsible", null);
    TableSection = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [typeof (_a = typeof Section_1.SectionProps !== "undefined" && Section_1.SectionProps) === "function" ? _a : Object])
    ], TableSection);
    return TableSection;
}(react_1.default.Component));
exports.default = TableSection;
